export const QUERY_CUSTOM_ERROR = (error: any) => ({ error: { status: 'CUSTOM_ERROR', error } });

export const QUERY_CONFIGURATION_NOT_LOADED = QUERY_CUSTOM_ERROR('Configuration not loaded.');